import { createStore, applyMiddleware } from 'redux'
import createHistory from 'history/createBrowserHistory'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import combinedReducers from './reducers'
import { composeWithDevTools } from 'redux-devtools-extension'

let history = createHistory()

var middlewares = [
    routerMiddleware(history),
    thunk
]

if (process.env.NODE_ENV !== 'production') {
    middlewares = [...middlewares, logger]
}

let composeEnhancers = composeWithDevTools({})
const store = createStore(combinedReducers, composeEnhancers(applyMiddleware(...middlewares)))

export {history, store}


// WEBPACK FOOTER //
// ./src/redux/store.js